import { FC, ReactNode, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { StaggerDelayContext } from './stagger-fade-in';

type StaggerItemProps = {
  children: ReactNode;
  className?: string;
};

export const StaggerItem: FC<StaggerItemProps> = ({ children, className }) => {
  const delay = useContext(StaggerDelayContext);

  return (
    <div
      className={twMerge('animate-reveal-up', className)}
      style={delay ? { animationDelay: `${delay}s` } : undefined}
    >
      {children}
    </div>
  );
};
